import * as React from 'react';
import ExpressStore from '@/stores/express';
import PageStore from '@/stores/page';
import doLog from '@/common/log';
import './index.less';
import MyLazyComponent from '@/common/lazy-load';

interface PropsType {
  trade: {
    paymentInfo: {
      logo: string[];
      payeePass: boolean; //商家是否开通
      payerAdmit: boolean; //买家白名单
      payerPass: boolean; //买家是否开通
      contentAction: string;
      oaOrderAction: string | undefined;
      content: string;
      oaAction?: string;
      applyAction: string;
    };
  };
  i18n: { [key: string]: string };
  product: {
    productId: number;
  };
}

const { useState } = React;

export default function Payments(props: PropsType) {
  const { trade, i18n, product } = props;

  const [visible, setVisible] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');
  const expressInfo = ExpressStore((state) => state.product);
  const secondScreen = PageStore((state) => state.secondScreen);
  const pageStore = PageStore((state) => state);
  const { isLoaded } = pageStore;
  if (!trade?.paymentInfo) return null;
  const IframeDialog = MyLazyComponent(() => import('../../common/dialog-iframe'));
  const { logo, payeePass, contentAction, oaAction, content } = trade?.paymentInfo;

  if (logo?.length === 0 && !payeePass) return null;

  // 需要通过物流更新参数
  const newContentAction = contentAction.replace(
    'productTypeValue',
    expressInfo.express ? 'RTS' : 'RFQ',
  );

  // 新增OA赊销服务
  const renderPayment = () => {
    return (
      <p>
        {oaAction && content ? (
          <a
            target="_blank"
            href={oaAction}
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          ></a>
        ) : (
          content
        )}
        &nbsp;
        <span
          className="blue-font"
          onClick={(e) => {
            e.preventDefault();
            doLog('/sc.details.taPayment', `second=${secondScreen}`);
            setIframeUrl(newContentAction);
            setVisible(true);
          }}
        >
          {i18n['detail_ta_view_details']}
        </span>
      </p>
    );
  };

  return (
    <div className="product-ta-content" data-taplus="payments">
      <p className="ta-content-left">
        <img src="//s.alicdn.com/@img/imgextra/i2/O1CN01mmz8xE1IO0BmI3sOH_!!6000000000882-2-tps-40-40.png" />
        <span>{i18n['Detail_Payments']}</span>
      </p>
      <div className="ta-content-right">
        <div
          className="logo-list"
          onClick={(e) => {
            e.preventDefault();
            setIframeUrl(newContentAction);
            setVisible(true);
          }}
        >
          {logo?.map((it: string) => (
            <div className="logo" key={it}>
              <img src={it} />
            </div>
          ))}
          <div className="ellipsis-logo">···</div>
        </div>
        {renderPayment()}
      </div>

      {isLoaded && (
        <IframeDialog
          iframeUrl={iframeUrl}
          visible={visible}
          setVisible={setVisible}
          productId={product.productId}
          action="paymentsViewDetail"
          dialogClass="promotion-dialog hide-close"
        />
      )}
    </div>
  );
}
